import * as React from 'react';
import {useState} from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select
} from "@mui/material";
import useSalepoints from "./useSalepoints.ts";

interface ShopDialogParams {
    open: boolean;
    handleClose: () => void,
}

const ShopDialog: React.FC<ShopDialogParams> = (props) => {
    const {cities, preferredCity, setPreferredCity, setFavoriteShop, shopsByCity,} = useSalepoints()
    const [shopRef, setShopRefRef] = useState("")
    const [cityID, setCityID] = useState(preferredCity?.id || "")
    return <Dialog
        open={props.open}
        onClose={props.handleClose}
        slotProps={{
            paper: {
                component: 'form',
                onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                    event.preventDefault();
                    const formData = new FormData(event.currentTarget);
                    const formJson = Object.fromEntries((formData as any).entries());
                    setFavoriteShop(formJson.shop)
                    props.handleClose();
                },
            },
        }}
    >
        <DialogTitle>Укажите пожалуйста магазин, в котором вы находитесь</DialogTitle>
        <DialogContent>
            <DialogContentText>
                Для корректного отображения остатка товара и формирования заказа укажите магазин в котором вы
                находитесь,
                изменить магазин можно в настройках в любое время.
            </DialogContentText>
            <FormControl sx={{m: 1, minWidth: 120}}>
                <InputLabel id="shopcity">Город</InputLabel>
                <Select
                    labelId="shopcity"
                    id="cityselect"
                    name={"city"}
                    value={cityID}
                    label="Город"
                    onChange={(e) => {
                        setCityID(e.target.value as number)
                        let cityID = e.target.value
                        let filteredCity = cities.filter(el => el.id === cityID)
                        if (filteredCity.length === 1) {
                            setPreferredCity(filteredCity[0])
                        }
                    }}
                >
                    {cities.map(city => (
                        <MenuItem key={city.id} value={city.id}>{city.name}</MenuItem>
                    ))}
                </Select>
                <FormHelperText>Выберите город</FormHelperText>
            </FormControl>
            <FormControl sx={{m: 1, minWidth: 120}}>
                <InputLabel id="shoplabel">Магазин</InputLabel>
                <Select
                    disabled={cityID === undefined}
                    labelId="shoppabel"
                    id="shopselect"
                    name={"shop"}
                    value={shopRef}
                    label="Магазин"
                    onChange={(e) => {
                        setShopRefRef(e.target.value as string)
                        let filtered = shopsByCity.filter(el => el.sanremoRef === e.target.value)
                        if (filtered.length === 1) {
                            setFavoriteShop(filtered[0].sanremoRef)
                        }
                    }}
                >{shopsByCity.map(shop => (
                    <MenuItem key={shop.sanremoRef} value={shop.sanremoRef}>{shop.name}</MenuItem>
                ))}
                </Select>
                <FormHelperText>Выберите магазин из списка</FormHelperText>
            </FormControl>
        </DialogContent>
        <DialogActions>
            <Button type="submit" variant="contained" disabled={shopRef.length === 0}>Выбрать</Button>
        </DialogActions>
    </Dialog>
}
export default ShopDialog